import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import "./ProjectCard.css";

const ProjectCard = ({
  imgUrl,
  title,
  category,
  description,
  projectLink,
  githubLink,
  faviconUrl,
  shortDescription,
}) => {
  return (
    <li>
      <div className="card">
        <img src={imgUrl} className="card__image" alt={title} />
        <div className="card__overlay">
          <div className="card__header">
            <svg className="card__arc" xmlns="http://www.w3.org/2000/svg">
              <path />
            </svg>
            <img className="card__thumb" src={faviconUrl} alt="" />
            <div className="card__header-text">
              <h3 className="card__title">{title}</h3>
              <span className="card__status">{category}</span>
            </div>
            <div className="card__icons">
              {projectLink && ( // Check if projectLink is available
                <a
                  href={projectLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="card__icon"
                >
                  <FontAwesomeIcon icon={faLink} />
                </a>
              )}
              {githubLink && ( // Check if githubLink is available
                <a
                  href={githubLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="card__icon"
                >
                  <FontAwesomeIcon icon={faGithub} />
                </a>
              )}
            </div>
          </div>
          <p className="card__description">{shortDescription}</p>
        </div>
      </div>
    </li>
  );
};

export default ProjectCard;
